import { render, staticRenderFns } from "./CategoryGroupSelect.vue?vue&type=template&id=4ca30ab0&scoped=true&"
import script from "./CategoryGroupSelect.vue?vue&type=script&lang=js&"
export * from "./CategoryGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca30ab0",
  null
  
)

export default component.exports